import { PageHeader } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { createUrlWithFiltersFromCurrentURL } from '../../utils/filterUtils'

const CreateOrder = ({ history }) => {
  const location = useLocation()
  const { user } = useAuth()

  return (
    <>
      <PageHeader
        className="site-page-header"
        title={`Create ${
          location.pathname.includes('orders') ? 'order' : 'adjustment'
        }`}
        style={{ backgroundColor: '#fff' }}
        onBack={
          location.pathname.includes('orders')
            ? () => {
                const url = createUrlWithFiltersFromCurrentURL('/orders')
                history.push(url)
              }
            : null
        }
      />
      <div className="order-wrapper">
        <Link
          className={user.role === 'production' ? 'is-hidden' : 'order-tile'}
          to={`${location.pathname}/new/${user.currentStore}${location.search}`}
        >
          New customer
        </Link>
        <Link
          className="order-tile"
          to={`${location.pathname}/select${location.search}`}
        >
          Existing customer
        </Link>
      </div>
    </>
  )
}

export default CreateOrder
